import React, { Component } from "react";
import { ListTabButton } from "../../../../common/list-tab/list-tab-button.component";
import { MODAL_TITLE, RECHARGE_INVENTORY_TYPE, Selected_Index, OUTPUT_SCOPE_TYPE, MODAL_CUSTOM_TITLE, MODAL_CUSTOM_MESSAGE, UPLOAD_TYPES } from "../../../../../constants/external-constants";
import ButtonIcon from "../../../../button";
import OutputConfigForm from "./output-config-form-layout.component/output-config-form.component";
import OutputScope from "./output-list-form.component/output-scope/output-scope.component";
import OutputColumns from "./output-list-form.component/output-columns/output-columns.component";
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { TRANSLATIONS as translation } from "../../../../../utils/constant.utils";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import { OutputConfigurationDetailsActions } from "../../../../../store/external/recharge-reducer/output-configuraton-details/output-configuration-details.reducer";
import { outputConfigurationActions } from "../../../../../store/external/recharge-reducer/output-configuration-reducer/output-configuration.reducer";
import { bindActionCreators } from 'redux';
import { generateConfigNumber, isObjectEqual, areDataEqual, validateAccessModule } from "../../../../../utils/helpers.utils";
import { Loading } from "../../../../common/loading";
import OutputRecord from "../output-form/output-form-record/output-form-record.component";
import OutputConfigurationComment from "../output-form/output-form-comments/output-form-comments.component";
import OutputConfirmationHistory from "../output-form/output-form-history/output-form-history.component";
import RechargeItems from "./output-recharge.component/output-recharge.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";
class OuputFormLayout extends Component {
    constructor(props){
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            hasInProgressOutputRecord: false,
            hasProcessingOutputRecordConfigName: false,
            haveError: false,
            selectedIndex: this.props.selectedIndex,
            circuitOutputScopeData: [],
            originalCircuitOutputScopeData: [],
            equipmentOutputScopeData: [],
            originalEquipmentOutputScopeData: [],
            otcOutputScopeData: [],
            originalOtcOutputScopeData: [],
            outputRecordsColumnData: [],
            originalOutputRecordsColumnData: [],
            originalMultipleOutputRecordsColumnData: [],
            isSaving: false,
            isLoading: true,
            outputScopeCircuitCount: 0,
            outputScopeEquipmentCount: 0,
            outputScopeOtcCount: 0,
            currentOutputConfigurationName: '',
            currentOutputConfigurationNumber: 0,
            listTab: [
                        {
                            "id": Selected_Index.i_Zero,
                            "label": "Details",
                            "hidden": false
                        },
                        {
                            "id": Selected_Index.i_One,
                            "label": "Recharge Items",
                            "hidden": false,
                            "disable": false
                        },
                        {
                            "id": Selected_Index.i_Two,
                            "label": "Output Records",
                            "hidden": false,
                            "disable": false
                        },
                        {
                            "id": Selected_Index.i_Three,
                            "label": "Comments",
                            "hidden": false,
                            "disable": false
                        },
                        {
                            "id": Selected_Index.i_Four,
                            "label": "History",
                            "hidden": false,
                            "disable": false
                        }
                    ],
        }
    }

    async componentDidMount() {
        const { isCreateNew, setConfigNumber, outputConfigurationId, getOutputConfigurationDetailsForm,
            checkRecentOutputRecordStatus, getCurrentInProgressOutputRecordConfigurationName, getCurrentInProgressOutputRecordConfigurationNumber
        } = this.props;
        this.setState({ isLoading: true });

        const hasInProgressOutputRecord = await checkRecentOutputRecordStatus(outputConfigurationId);
        const currentOutputConfigurationName = await getCurrentInProgressOutputRecordConfigurationName();
        const currentOutputConfigurationNumber = parseInt(await getCurrentInProgressOutputRecordConfigurationNumber());

        this.setState({
            hasInProgressOutputRecord,
            currentOutputConfigurationName,
            currentOutputConfigurationNumber
        });

        if (isCreateNew) {
            var configNumber = generateConfigNumber();
            setConfigNumber(configNumber);
            this.setState({ isLoading: false });
        }
        else {
            await getOutputConfigurationDetailsForm(outputConfigurationId).then(() =>{

                const { circuitDataTable, equipmentDataTable, otcDataTable, outputColumnsDatatable } = this.props.outputConfigurationDetails
                const originalCircuitOutputScopeDataCopy = JSON.parse(JSON.stringify(circuitDataTable?.dataTable[0]?.dataItem))
                const originalEquipmentOutputScopeDataCopy = JSON.parse(JSON.stringify(equipmentDataTable?.dataTable[0]?.dataItem))
                const originalOtcOutputScopeDataCopy = JSON.parse(JSON.stringify(otcDataTable?.dataTable[0]?.dataItem))
                const originalOutputRecordsColumnDataCopy = JSON.parse(JSON.stringify(outputColumnsDatatable?.dataTable[0]?.dataItem))
                this.setState({  originalCircuitOutputScopeData: originalCircuitOutputScopeDataCopy,
                    originalEquipmentOutputScopeData: originalEquipmentOutputScopeDataCopy,
                    originalOtcOutputScopeData: originalOtcOutputScopeDataCopy,
                    originalOutputRecordsColumnData: originalOutputRecordsColumnDataCopy,
                    outputScopeCircuitCount: this.props.outputConfigurationDetails.outputScopeCircuitCount,
                    outputScopeEquipmentCount: this.props.outputConfigurationDetails.outputScopeEquipmentCount,
                    outputScopeOtcCount: this.props.outputConfigurationDetails.outputScopeOtcCount
                })
            });
        }
        const hasProcessingOutputRecordConfigName = currentOutputConfigurationNumber !== 0 && currentOutputConfigurationNumber === parseInt(outputConfigurationId);

        this.setState({
            hasProcessingOutputRecordConfigName
        });
        this.setState({ isLoading: false });
        window.scrollTo(0, 0);
    }

    FilterIndex = async (tabIndex) => {
        const { outputConfigurationId, checkRecentOutputRecordStatus, getCurrentInProgressOutputRecordConfigurationName, getCurrentInProgressOutputRecordConfigurationNumber } = this.props;

        // Refresh the in-progress output record status when switching tabs
        const hasInProgressOutputRecord = await checkRecentOutputRecordStatus(outputConfigurationId);
        const currentOutputConfigurationName = await getCurrentInProgressOutputRecordConfigurationName();
        const currentOutputConfigurationNumber = parseInt(await getCurrentInProgressOutputRecordConfigurationNumber());
        const hasProcessingOutputRecordConfigName = currentOutputConfigurationNumber !== 0 && currentOutputConfigurationNumber === parseInt(outputConfigurationId);

        this.setState({
            selectedIndex: tabIndex,
            hasInProgressOutputRecord,
            currentOutputConfigurationName,
            currentOutputConfigurationNumber,
            hasProcessingOutputRecordConfigName
        });

        this.renderTabContent(tabIndex);
    }

    renderTabContent = (index) => {
        this.setState({ selectedIndex: index });
    }

    handleCloseForm = () =>{
        const { handleClose, resetAllForm, getOutputConfiguration, getOutputConfigurationDropdownlist } = this.props;
        handleClose();
        resetAllForm();
        getOutputConfiguration();
        getOutputConfigurationDropdownlist();
    }

    toLocaleLanguage = (key, isCapitalize=true) => {
            const { locale } = this.props;
            if (locale === null || locale === '')
                return translation[translation['defaultLocaleLanguage']][key];
            
            return isCapitalize ? translation[locale][key]?.toUpperCase() : translation[locale][key];
    }

    activeListTab = (listTab) => {
        const { rechargeInventoryId } = this.props;

        return listTab.map(item => {
            var disabled = item.disable;
            if ((parseInt(item.id) === parseInt(Selected_Index.i_One) || parseInt(item.id) === parseInt(Selected_Index.i_Two)) && rechargeInventoryId > 0) {
                disabled = false;
            }
            
            return {
                ...item,
                disable: disabled
            };
        })
    }

    handleButtonConfirmation = async (outputConfigId = 0, validate = 1) => {
        const { saveOutputConfiguration, getOutputConfigurationDetailsForm, outputConfigurationId, isCreateNew, checkRecentOutputRecordStatus, getCurrentInProgressOutputRecordConfigurationName, getCurrentInProgressOutputRecordConfigurationNumber } = this.props;
        const { circuitOutputScopeData, equipmentOutputScopeData, otcOutputScopeData, outputRecordsColumnData } = this.state;

        const outputScopeFilter = { circuitOutputScopeData, equipmentOutputScopeData, otcOutputScopeData, outputRecordsColumnData };

        const hasInProgressOutputRecord = await checkRecentOutputRecordStatus(outputConfigurationId);
        const currentOutputConfigurationName = await getCurrentInProgressOutputRecordConfigurationName();
        const currentOutputConfigurationNumber = parseInt(await getCurrentInProgressOutputRecordConfigurationNumber());
        const hasProcessingOutputRecordConfigName = currentOutputConfigurationNumber !== 0 && currentOutputConfigurationNumber === parseInt(outputConfigurationId);

        this.setState({
            hasInProgressOutputRecord,
            currentOutputConfigurationName,
            hasProcessingOutputRecordConfigName,
            currentOutputConfigurationNumber
        });

        if (hasProcessingOutputRecordConfigName) {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(
                true,
                MODAL_CUSTOM_TITLE.Notification,
                `Output configuration ${currentOutputConfigurationName} is currently running. Please complete the process first.`
            );
            return;
        }

        this.setState({
            isSaving: true
        });

        const result = await saveOutputConfiguration(outputConfigId, validate, outputScopeFilter);

        if (result.success === false) {
            if (result.isValid) {
                this.handleButtonConfirmation(outputConfigId, 0);
                return;
            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);

                this.setState({
                    haveError: true,
                    isSaving: false
                });
                return;
            }
        }
        
        if (!isCreateNew) {
            this.setState({
                haveError: true,
                isSaving: true
            });

            await getOutputConfigurationDetailsForm(outputConfigurationId).then(() => {

                const { circuitDataTable, equipmentDataTable, otcDataTable, outputColumnsDatatable } = this.props.outputConfigurationDetails
                const originalCircuitOutputScopeDataCopy = JSON.parse(JSON.stringify(circuitDataTable?.dataTable[0]?.dataItem))
                const originalEquipmentOutputScopeDataCopy = JSON.parse(JSON.stringify(equipmentDataTable?.dataTable[0]?.dataItem))
                const originalOtcOutputScopeDataCopy = JSON.parse(JSON.stringify(otcDataTable?.dataTable[0]?.dataItem))
                const originalOutputRecordsColumnDataCopy = JSON.parse(JSON.stringify(outputColumnsDatatable?.dataTable[0]?.dataItem))
                this.setState({
                    originalCircuitOutputScopeData: originalCircuitOutputScopeDataCopy,
                    originalEquipmentOutputScopeData: originalEquipmentOutputScopeDataCopy,
                    originalOtcOutputScopeData: originalOtcOutputScopeDataCopy,
                    originalOutputRecordsColumnData: originalOutputRecordsColumnDataCopy,
                    outputScopeCircuitCount: this.props.outputConfigurationDetails.outputScopeCircuitCount,
                    outputScopeEquipmentCount: this.props.outputConfigurationDetails.outputScopeEquipmentCount,
                    outputScopeOtcCount: this.props.outputConfigurationDetails.outputScopeOtcCount,
                    haveError: false,
                    isSaving: false
                })
            });
        }
        this.setState({
            isSaving: false
        });
        this.toggleSaveModal(false);
        this.toggleSaveNotif(true, MODAL_TITLE.SAVE, result.message);

        return;
    };


    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    toggleSaveNotif = async (isShow, title, message) => {
        const { saveNotif } = this.state;
        const { getOutputConfiguration, resetAllForm } = this.props

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && (saveNotif.message === "Output Configuration has been created.")) {
            this.handleCloseForm();
            getOutputConfiguration();
            resetAllForm();
        }
    }

    handleFetchCircuitOutputScopeData = async (data) => {
        let newData = [];
        if (Array.isArray(data[0])) {
            newData = [...data[0]]
        } else {
            newData = [[...data]]
        }

        this.setState({
            circuitOutputScopeData: newData,
            originalCircuitOutputScopeData:[]
        })
    }

    handleFetchEquipmentOutputScopeData = async (data) => {
        this.setState({
            equipmentOutputScopeData: data,
            originalEquipmentOutputScopeData:[]
        })
    }

    handleFetchOtcOutputScopeData = async (data) => {
        this.setState({
            otcOutputScopeData: data,
            originalOtcOutputScopeData:[]
        })
    }

    handleFetchOutputColumnData = async (data) => {
        this.setState({
            outputRecordsColumnData: data,
            originalOutputRecordsColumnData:[]
        })
    }
    updateIsCreateNew= (isCreateNew) => {
        this.setState({
            isCreateNew: isCreateNew
        })
    }

    disableSaveChanges = () => {
        const { $form, outputConfigurationDetailsForm, outputConfigurationDetails, isCreateNew } = this.props;
        const { configurationNumber, configurationName, fileName, fileFormatId, fileDelimeter, isGenerateJsonFile, currencyId } = outputConfigurationDetailsForm.outputConfiguration;
        const { outputConfiguration } = outputConfigurationDetailsForm;
        const { hasProcessingOutputRecordConfigName } = this.state;

        // normalize currency once
        const normalizedCurrency = currencyId === 'none' || currencyId === '182' ? null : currencyId;

        const outputConfigurationData = {
            ...outputConfiguration,
            currencyId: normalizedCurrency,
        };
        const disableSaveBtn = !configurationNumber || !configurationName || !fileName || !fileFormatId ||
            !fileDelimeter || !isGenerateJsonFile || !(normalizedCurrency !== undefined);
       
        if (disableSaveBtn || hasProcessingOutputRecordConfigName) {
            return true;
        }

        if(!isCreateNew){

            const loaded = $form?.loadedValue;
            const unchangedOutputConfiguration = !loaded || isObjectEqual(loaded.outputConfiguration, outputConfigurationData);

            const outputScopeCircuit = outputConfigurationDetails.circuitDataTable?.dataTable?.length > 0
                ? areDataEqual(this.state.originalCircuitOutputScopeData, JSON.parse(JSON.stringify(outputConfigurationDetails.circuitDataTable?.dataTable?.[0].dataItem)))
                : true;
            const outputScopeEquipment = outputConfigurationDetails.equipmentDataTable?.dataTable?.length > 0
                ? areDataEqual(this.state.originalEquipmentOutputScopeData, JSON.parse(JSON.stringify(outputConfigurationDetails.equipmentDataTable?.dataTable?.[0].dataItem)))
                : true;
            const outputScopeOtc = outputConfigurationDetails.otcDataTable?.dataTable?.length > 0
                ? areDataEqual(this.state.originalOtcOutputScopeData, JSON.parse(JSON.stringify(outputConfigurationDetails.otcDataTable?.dataTable?.[0].dataItem)))
                : true;
            const outputColumn = outputConfigurationDetails.outputColumnsDatatable?.dataTable?.length > 0
                ? areDataEqual(this.state.originalOutputRecordsColumnData, JSON.parse(JSON.stringify(outputConfigurationDetails.outputColumnsDatatable?.dataTable?.[0].dataItem)))
                : true;
            return unchangedOutputConfiguration && outputScopeCircuit && outputScopeEquipment && outputScopeOtc && outputColumn;
        }
        return false;
    }

    handleGenerateOuputConfirmation = () => {
        this.toggleSaveModal(true, MODAL_CUSTOM_TITLE.OutputGeneration, MODAL_CUSTOM_MESSAGE.generate_output_confirmation, this.handleGenerateOutputNotification);
    }

    handleGenerateOutputNotification = async () => {
        const { performOutputGeneration, outputConfigurationId, outputConfigurationDetailsForm, checkRecentOutputRecordStatus, getCurrentInProgressOutputRecordConfigurationName, getCurrentInProgressOutputRecordConfigurationNumber } = this.props;
        const { configurationName } = outputConfigurationDetailsForm.outputConfiguration;
        const hasInProgressOutputRecord = await checkRecentOutputRecordStatus(outputConfigurationId);
        const currentOutputConfigurationName = await getCurrentInProgressOutputRecordConfigurationName();
        const currentOutputConfigurationNumber = parseInt(await getCurrentInProgressOutputRecordConfigurationNumber());
        const hasProcessingOutputRecordConfigName = currentOutputConfigurationNumber !== 0 && currentOutputConfigurationNumber === parseInt(outputConfigurationId);

        this.setState({
            hasInProgressOutputRecord,
            currentOutputConfigurationName,
            currentOutputConfigurationNumber,
            hasProcessingOutputRecordConfigName
        });

        if (hasInProgressOutputRecord) {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(
                true,
                MODAL_CUSTOM_TITLE.Notification,
                `Output configuration ${currentOutputConfigurationName} is currently running. Please execute the next action necessary to complete the process.`
            );
            return;
        }

        this.toggleSaveModal(false);
        this.toggleSaveNotif(true, MODAL_CUSTOM_TITLE.Notification, MODAL_CUSTOM_MESSAGE.generate_output_notification);
        performOutputGeneration(outputConfigurationId, outputConfigurationDetailsForm.outputConfiguration.isGenerateJsonFile, UPLOAD_TYPES.RechargingOutputGeneration);
        this.setState({
            hasInProgressOutputRecord: true,
            hasProcessingOutputRecordConfigName: true,
            currentOutputConfigurationName: configurationName
        });
    };

    render() {
        const { listTab, selectedIndex, isSaving, hasInProgressOutputRecord, currentOutputConfigurationName } = this.state;
        const { outputConfigurationDropdownlist, outputConfigurationDetailsForm, setConfigNumber, setFileDelimiter, outputConfigurationDetails,
                outputConfigurationId, isCreateNew } = this.props;
        const { circuitOutputScope, equipmentOutputScope, otcOutputScope, outputColumnScope, multipleOutputColumnScope } = outputConfigurationDetailsForm;
        const { circuitDataTable, equipmentDataTable, otcDataTable, outputColumnsDatatable, outputColumnsHeaders, outputScopeCircuitCount, outputScopeEquipmentCount, outputScopeOtcCount } = this.props.outputConfigurationDetails;
        const { fileName, fileFormatId, fileDelimeter, isGenerateJsonFile } = outputConfigurationDetailsForm.outputConfiguration;

        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdOutputConfigurationyRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdOutputConfigurationRW])



        const optionLabelKey =
        {
            Key: 'FilterId',
            Value: 'FilterName'
        }

        const outputColumnoptionLabelKey =
        {
            Key: 'ColumnSourceID',
            Value: 'ColumnName'
        }

        return(
            <>
                <ConfirmationModal
                    title={this.state.saveModal.title}
                    messageBody={this.state.saveModal.messageBody}
                    confirmAction={this.state.saveModal.confirmAction}
                    closeLabel={this.toLocaleLanguage("cancel_button", false)}
                    confirmLabel={this.toLocaleLanguage("yes_button", false)}
                    disabled={this.state.isSaving}
                    ref={this.ConfirmationModal}
                />
            {
                this.state.isLoading || isSaving ?
                <Loading/>
                :
                <div className="layout-container">
                <ButtonIcon onClick={this.handleCloseForm} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back" />
                    {listTab ? <ListTabButton listData={this.activeListTab(listTab)} selectedIndex={selectedIndex} FilterIndex={this.FilterIndex} />
                        : null}
                {
                    selectedIndex === Selected_Index.i_Zero &&
                    <>
                    <div className="details-container date-picker-main-container">                      

                            <OutputConfigForm
                                outputConfigurationDropdownlist={outputConfigurationDropdownlist}
                                outputConfigurationDetailsForm={outputConfigurationDetailsForm}
                                setConfigNumber={setConfigNumber}
                                setFileDelimiter={(e, v) => setFileDelimiter(e, v)}
                            
                            />
                                <div className="horizontal-separator" />

                                <OutputScope
                                    title={"output_scope_circuit"}
                                    columnData={outputConfigurationDropdownlist.CircuitColumnSource}
                                    operatorData={outputConfigurationDetails.filterOperatorOptions}
                                    optionData={outputConfigurationDropdownlist.ConditionalOption}
                                    optionLabelKey={optionLabelKey}
                                    fieldForm={circuitOutputScope}
                                    fieldProp={'outputConfigurationDetailsForm.circuitOutputScope.'}
                                    outputScope={RECHARGE_INVENTORY_TYPE.Circuit.id}
                                    handleFetchData={this.handleFetchCircuitOutputScopeData}
                                    extractHoverMessage="output_scope_circuit"
                                    addTooltipText="add_output_circuit"
                                    updateTooltipText="update_output_circuit"
                                    filterOperatorOptions={(e, v, o) => this.props.filterOperatorOptions(e, v, o)}
                                    filterType={outputConfigurationDetails.filterType}
                                    handleResetForm={(e) => this.props.handleResetForm(e)}
                                    addOutputScope={this.props.addOutputScopeCircuit}
                                    dataItem={circuitDataTable?.dataTable[0]?.dataItem ?? []}
                                    extractCount={outputScopeCircuitCount}
                                    isCreateNew={isCreateNew}
                                    outputScopeExtractId={OUTPUT_SCOPE_TYPE.circuit.id}
                                    isExtractDisabled={outputConfigurationDetails.circuitDataTable?.dataTable?.[0]?.dataItem.length > 0}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                />

                                <OutputScope
                                    title={"output_scope_equipment"}
                                    columnData={outputConfigurationDropdownlist.EquipmentColumnSource}
                                    operatorData={outputConfigurationDetails.filterOperatorOptions}
                                    optionData={outputConfigurationDropdownlist.ConditionalOption}
                                    optionLabelKey={optionLabelKey}
                                    fieldForm={equipmentOutputScope}
                                    fieldProp={'outputConfigurationDetailsForm.equipmentOutputScope.'}
                                    outputScope={RECHARGE_INVENTORY_TYPE.Equipment.id}
                                    handleFetchData={this.handleFetchEquipmentOutputScopeData}
                                    extractHoverMessage="output_scope_equipment"
                                    addTooltipText="add_output_equipment"
                                    updateTooltipText="update_output_equipment"
                                    filterOperatorOptions={(e, v, o) => this.props.filterOperatorOptions(e, v, o)}
                                    filterType={outputConfigurationDetails.filterType}
                                    handleResetForm={(e) => this.props.handleResetForm(e)}
                                    addOutputScope={this.props.addOutputScopeEquipment}
                                    dataItem={equipmentDataTable?.dataTable[0]?.dataItem ?? []}
                                    extractCount={outputScopeEquipmentCount}
                                    isCreateNew={isCreateNew}
                                    outputScopeExtractId={OUTPUT_SCOPE_TYPE.equipment.id}
                                    isExtractDisabled={outputConfigurationDetails.equipmentDataTable?.dataTable?.[0]?.dataItem.length  > 0}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                />

                                <OutputScope
                                    title={"output_scope_otc"}
                                    columnData={outputConfigurationDropdownlist.OtcColumnSource}
                                    operatorData={outputConfigurationDetails.filterOperatorOptions}
                                    optionData={outputConfigurationDropdownlist.ConditionalOption}
                                    optionLabelKey={optionLabelKey}
                                    fieldForm={otcOutputScope}
                                    fieldProp={'outputConfigurationDetailsForm.otcOutputScope.'}
                                    outputScope={RECHARGE_INVENTORY_TYPE.OTC.id}
                                    handleFetchData={this.handleFetchOtcOutputScopeData}
                                    extractHoverMessage="output_scope_otc"
                                    addTooltipText="add_output_otc"
                                    updateTooltipText="update_output_otc"
                                    filterOperatorOptions={(e, v, o) => this.props.filterOperatorOptions(e, v, o)}
                                    filterType={outputConfigurationDetails.filterType}
                                    handleResetForm={(e) => this.props.handleResetForm(e)}
                                    addOutputScope={this.props.addOutputScopeOtc}
                                    dataItem={otcDataTable?.dataTable[0]?.dataItem ?? []}
                                    extractCount={outputScopeOtcCount}
                                    isCreateNew={isCreateNew}
                                    outputScopeExtractId={OUTPUT_SCOPE_TYPE.otc.id}
                                    isExtractDisabled={outputConfigurationDetails.otcDataTable?.dataTable?.[0]?.dataItem.length > 0}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                />

                                <OutputColumns 
                                    title={"output_columns"}
                                    columnData={outputConfigurationDropdownlist.OutputColumnSource}
                                    columnMulitpleData={outputConfigurationDropdownlist.OutputMultipleColumnSource}
                                    columFormatData={outputConfigurationDetails.filterColumnFormat}
                                    columFormat1Data={outputConfigurationDetails.filterColumn1Format}
                                    columFormat2Data={outputConfigurationDetails.filterColumn2Format}
                                    columFormat3Data={outputConfigurationDetails.filterColumn3Format}
                                    fieldForm={outputColumnScope}
                                    fieldProp={'outputConfigurationDetailsForm.outputColumnScope.'}
                                    fieldFormMultiple={multipleOutputColumnScope}
                                    fieldPropMultiple={'outputConfigurationDetailsForm.multipleOutputColumnScope.'}
                                    filterType={outputConfigurationDetails.filterType}
                                    outputScope={RECHARGE_INVENTORY_TYPE.OTC.id}
                                    handleFetchData={this.handleFetchOutputColumnData}
                                    headerItem={outputColumnsHeaders}
                                    dataItem={outputColumnsDatatable?.dataTable[0]?.dataItem ?? []}
                                    optionLabelKey={outputColumnoptionLabelKey}
                                    isCreateNew={isCreateNew}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                />

                        </div>
                        {
                            hasInProgressOutputRecord &&
                            <span className="text-danger fw-bold fs-6">
                                Output configuration {currentOutputConfigurationName} is currently running. Please execute the next action necessary to complete the process.
                            </span>
                        }
                        <div className="button-container d-flex align-items-center">
                            { isReadAndWrite &&
                                <div className="create-output">
                                <div className="tooltip-container">
                                    <div className="btn-tooltiptext">
                                        {true ?
                                            <Button className='create-output-btn btn btn-primary rounded-5' 
                                                disabled={!this.disableSaveChanges() || hasInProgressOutputRecord || isCreateNew}
                                                onClick={() => this.handleGenerateOuputConfirmation()}
                                                type="button">
                                                Generate Output
                                            </Button>
                                            : null}
                                        <div>
                                            <span className="tooltip-text-save start-50 translate-middle-x top--35">{this.toLocaleLanguage("generate_output", false)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            <div className='save-btn-container'>
                                <NotificationModal
                                    show={this.state.saveNotif.show}
                                    title={this.state.saveNotif.title}
                                    message={this.state.saveNotif.message}
                                    handleModal={() => this.toggleSaveNotif(false)}
                                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                />                    
                            
                               { isReadAndWrite &&
                                    <div className="tooltip-container">
                                    <div className="btn-tooltiptext">
                                        {true ?
                                            <Button className='save-details-btn btn btn-primary' 
                                                disabled={this.disableSaveChanges()}
                                                onClick={() => this.handleButtonConfirmation(outputConfigurationId)}
                                                type="button">
                                                Save Changes
                                            </Button>
                                            : null}
                                        <div className="save-tooltip-text-container">
                                            <span className="tooltip-text-save">{this.toLocaleLanguage("save_output_config", false)}</span>
                                        </div>
                                    </div>
                                </div>
                               }
                            </div>
                        </div>
                    </>
                }

                {
                    selectedIndex === Selected_Index.i_One &&
                    <RechargeItems
                        outputConfigurationId={outputConfigurationId}
                        fileFormatId={fileFormatId}
                        fileName={fileName}
                        fileDelimeter={fileDelimeter}
                        isGenerateJsonFile={isGenerateJsonFile}
                        isReadAndWrite={isReadAndWrite}
                    />
                }

                {
                    selectedIndex === Selected_Index.i_Two &&
                    <OutputRecord 
                        outputConfigurationId={outputConfigurationId}
                        isReadAndWrite={isReadAndWrite}
                   />
                }

                {
                    selectedIndex === Selected_Index.i_Three &&
                    <OutputConfigurationComment 
                        outputConfigurationId={outputConfigurationId}
                        isReadAndWrite={isReadAndWrite}
                        isReadAndExtractOnly={isReadAndExtractOnly}
                    />
                }

                {
                    selectedIndex === Selected_Index.i_Four &&
                    <OutputConfirmationHistory 
                        outputConfigurationId={outputConfigurationId}
                        isReadAndWrite={isReadAndWrite}
                        isReadAndExtractOnly={isReadAndExtractOnly}
                    />
                }
            </div>
            }
            </>
        )
    }
}

export default connect(
    state => {
        const { translation, outputConfigurationDetails } = state;
        const { outputConfigurationDetailsForm, forms: { outputConfigurationDetailsForm: { $form } } } = state.form;
        return {
            ...translation
            , outputConfigurationDetails
            , outputConfigurationDetailsForm
            , $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, OutputConfigurationDetailsActions, outputConfigurationActions),
            dispatch
        ),
    })
)(OuputFormLayout);